'use client'

import { ContentForm } from 'features/generator/ContentForm'
import {
	qrNameFormConfig,
	socialLinksFormConfig,
	TQrContentFormSection,
	welcomeScreenFormConfig,
} from 'features/generator/contentFormSections'
import { businessInfoFormConfig } from 'features/generator/contentFormSections/BusinessInfoForm'
import { contactInfoFormConfig } from 'features/generator/contentFormSections/ContactInfoForm/ContactInfoForm'
import { facilitiesFormConfig } from 'features/generator/contentFormSections/FacilitiesForm/FacilitiesForm'
import { locationFormConfig } from 'features/generator/contentFormSections/LocationForm/LocationForm'
import { openingHoursFormConfig } from 'features/generator/contentFormSections/OpeningHoursForm/OpeningHoursForm'
import { summaryFormConfig } from 'features/generator/contentFormSections/SummaryForm/SummaryForm'
import { QR_TYPE, TContentFormProps } from 'features/generator/generatorTypes'
import { useTranslations } from 'next-intl'
import { forwardRef } from 'react'

import { contentDesignFormConfig } from '@/content-from-sections/client'

import { ImageField } from '../../contentFormSections/ImageForm'
import {
	TContentFormHandle,
	TContentFormSectionPartialProps,
} from '../../contentFormSections/qrContentFormTypes'

export const BusinessPageContentForm = (props: TContentFormProps) => {
	const t = useTranslations()

	const BusinessPageImageField = forwardRef<
		TContentFormHandle,
		TContentFormSectionPartialProps
	>((props, ref) => (
		<ImageField
			{...props}
			ref={ref}
			aspect={216 / 96}
			showCropDialog={false}
			maintainAspectRatio={true}
		/>
	))

	BusinessPageImageField.displayName = 'BusinessPageImageField'

	const config = {
		formSectionList: [
			contentDesignFormConfig(t, BusinessPageImageField),
			businessInfoFormConfig(t),
			openingHoursFormConfig(t),
			contactInfoFormConfig(t),
			locationFormConfig(t),
			facilitiesFormConfig(t),
			summaryFormConfig(t),
			socialLinksFormConfig(t),
			welcomeScreenFormConfig(t),
			qrNameFormConfig(t),
		] satisfies TQrContentFormSection[],
	}

	return (
		<ContentForm qrType={QR_TYPE.BusinessPage} config={config} {...props} />
	)
}

BusinessPageContentForm.displayName = 'BusinessPageContentForm'
